import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { formEditorFormFieldsUpdatePatch } from '../../../../../api-client/api-gqadmin-client';

const initialState = {
    loading: false,
    error: null,
    data: null,
};

export const patchFormEditorFormFieldsUpdate = createAsyncThunk(
    'patchFormEditorFormFieldsUpdate/Patch',
    async (body, { rejectWithValue }) => {
        try {
            const response = await formEditorFormFieldsUpdatePatch(body);
            const data = response.data;
            return data;
        } catch (err) {
            const errObj = {
                type: 'PATCH_GQ_ADMIN_FORM_EDITOR_FORM_FIELDS_UPDATE_FAILURE',
                error: err,
            };
            return rejectWithValue(err?.response?.data || errObj);
        }
    },
);

export const patchFormEditorFormFieldsUpdateSlice = createSlice({
    name: 'patchFormEditorFormFieldsUpdate',
    initialState,
    extraReducers: {
        [patchFormEditorFormFieldsUpdate.pending]: (state) => {
            state.loading = true;
        },
        [patchFormEditorFormFieldsUpdate.fulfilled]: (state, { payload }) => {
            state.loading = false;
            state.data = payload?.data;
        },
        [patchFormEditorFormFieldsUpdate.rejected]: (state, { payload }) => {
            state.loading = false;
            state.data = null;
            state.error = payload;
        },
    },
});

export const patchFormEditorFormFieldsUpdateSelector = (state) => state.patchFormEditorFormFieldsUpdate;
export const patchFormEditorFormFieldsUpdateReducer = patchFormEditorFormFieldsUpdateSlice.reducer;
